import { NbMenuItem } from '@nebular/theme';

export const MENU_SETTINGS: NbMenuItem =
{
  title: 'Configuración',
  icon: 'settings-outline',
  children: [
    {
      title: 'Perfil',
      link: '/views/settings/profile',
    }, {
      title: 'Grupos de trámites',
      link: '/views/settings/request-group',
    }, {
      title: 'Tipos de trámites',
      link: '/views/settings/request-type',
    }, {
      title: 'Requisitos',
      link: '/views/settings/requirement',
    }, {
      title: 'Requisitos de grupo',
      link: '/views/settings/request-group-requirement',
    }, {
      title: 'Requisitos de trámite',
      link: '/views/settings/request-type-requirement',
    },
  ],
};
